import styles from "../EditOrganisation/EditOrganisation.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { Navigate, useParams } from 'react-router-dom';
import { AddUserForm } from '../../components/AddUserForm';
import { UsersTable } from '../../components/UsersTable';
import React, { useContext, useRef, useState } from 'react';
import { UserFormData } from '../../apollo/types/UserFormData';
import { FormikProps } from 'formik';
import { OrganisationData } from '../../apollo/types/OrganisationData';
import { useMutation, useQuery } from '@apollo/client';
import {
    CREATE_USER, GET_ASSESSMENT_OPTIONS,
    ORGANISATION,
    ORGANISATIONS,
    ORGANISATIONS_LIST, UPDATE_ASSESSMENT_OPTIONS,
    UPDATE_ORGANISATION, USERS_OF_ORGANISATION
} from '../../apollo/queries';
import { OrganisationDataPlusUrl, OrganisationForm } from '../../components/OrganisationForm';
import { client } from '../../apollo/client';
import { FileUpload } from '../../components/common/FileUpload';
import { AssessmentOptionsForm } from '../../components/AssessmentOptionsForm';
import { AssessmentOptions } from '../../apollo/types/AssessmentOptions';
import { UserContext } from '../../context/UserContext';

export const EditOrganisation = () => {
    const { id } = useParams();

    const initialUserFormValues = {
        name: "",
        emailAddress: "",
        userFunction: "",
        language: "nl",
    }

    const formikRefUserForm = useRef<FormikProps<UserFormData>>(null);
    const formikRefOrganisationForm = useRef<FormikProps<OrganisationDataPlusUrl>>(null);
    const [userFormData, setUserFormData] = useState<UserFormData>(initialUserFormValues)
    const [organisationFormData, setOrganisationFormData] = useState<OrganisationDataPlusUrl|undefined>(undefined)

    const formikRefAssOptionsForm = useRef<FormikProps<AssessmentOptions>>(null);
    const [assessmentOptionsData, setAssessmentOptionsData] = useState<AssessmentOptions|undefined>(undefined)

    const [features, setFeatures ] = useState([])
    const [updatingOrganisationSuccessful, setUpdatingOrganisationSuccessful] = useState(false);
    const [updatingOrganisationError, setUpdatingOrganisationError] = useState(false);

    const [updatingAssessmentOptionsSuccessful, setUpdatingAssessmentOptionsSuccessful] = useState(false);
    const [updatingAssessmentOptionsError, setUpdatingAssessmentOptionsError] = useState(false);

    const [updatingUserSuccessful, setUpdatingUserSuccessful] = useState(false);
    const [updatingUserError, setUpdatingUserError] = useState(false);
    const [userPassword, setUserPassword] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);


    useQuery(ORGANISATION, {
        variables: {
            // @ts-ignore
            organisationId: parseInt(id)
        },
        onCompleted: (someData) => {
            someData.organisation.venture = someData.organisation.name
            someData.organisation.parentId = someData.organisation.parent.id
            setFeatures(someData.organisation.features)

            delete someData.organisation.features;
            delete someData.organisation.parent;
            delete someData.organisation.name;

            setOrganisationFormData(someData.organisation)
        },
        fetchPolicy: "no-cache"
    });

    useQuery(GET_ASSESSMENT_OPTIONS, {
        variables: {
            // @ts-ignore
            organisationId: parseInt(id)
        },
        onCompleted: (someData) => {
            setAssessmentOptionsData(someData.assessmentOptionsByOrgId)
        },
        fetchPolicy: "no-cache"
    });

    const [updateOrganisationAction] = useMutation(UPDATE_ORGANISATION, {
        onCompleted: (data) => {
            if(data !== null && data.updateOrganisation && data.updateOrganisation.code === 200) {
                setUpdatingOrganisationSuccessful(true)
                setUpdatingOrganisationError(false)
                setTimeout(() => {
                    setUpdatingOrganisationSuccessful(false);
                }, 1500)
            } else {
                setUpdatingOrganisationSuccessful(false)
                setUpdatingOrganisationError(true)
                setErrorMessage(data.errors[0].message)
            }
            client.refetchQueries({
                include: [ORGANISATIONS_LIST, ORGANISATIONS]
            })
        },
        onError: (errors) => {
            setUpdatingOrganisationError(true)
            setUpdatingOrganisationSuccessful(false)
            // @ts-ignore
            setErrorMessage(errors.message)
        }
    });

    const [updateAssessmentOptions] = useMutation(UPDATE_ASSESSMENT_OPTIONS, {
        onCompleted: (data) => {
            if(data !== null && data.updateAssessmentOptions && data.updateAssessmentOptions.id) {
                setUpdatingAssessmentOptionsSuccessful(true)
                setUpdatingAssessmentOptionsError(false)
                setTimeout(() => {
                    setUpdatingAssessmentOptionsSuccessful(false);
                }, 1500)
            } else {
                setUpdatingAssessmentOptionsSuccessful(false)
                setUpdatingAssessmentOptionsError(true)
                setErrorMessage(data.errors[0].message)
            }
        },
        onError: (errors) => {
            setUpdatingAssessmentOptionsError(true)
            setUpdatingOrganisationSuccessful(false)
            // @ts-ignore
            setErrorMessage(errors.message)
        }
    });

    const [createUserAction] = useMutation(CREATE_USER, {
        onCompleted: (data) => {
            if(data !== null && data.addUserToOrganisation && data.addUserToOrganisation.code === 200) {
                setUpdatingUserSuccessful(true)
                setUpdatingUserError(false)
                setUserPassword(data.addUserToOrganisation.userPassword)
                setTimeout(() => {
                    setUpdatingUserError(false)
                    formikRefUserForm.current?.resetForm()
                }, 1500)
                client.refetchQueries({
                    include: [USERS_OF_ORGANISATION]
                })
            } else {
                setUpdatingUserSuccessful(false)
                setUpdatingUserError(true)
                setErrorMessage(data.errors[0].message)
                setTimeout(() => {
                    setUpdatingUserSuccessful(false);
                    setUpdatingUserError(false)
                }, 2500)
            }
        },
        onError: (errors) => {
            setUpdatingUserError(true)
            setUpdatingUserSuccessful(false)
            // @ts-ignore
            setErrorMessage(errors.message)
            setTimeout(() => {
                setUpdatingUserSuccessful(false);
                setUpdatingUserError(false)
            }, 2500)
        },

    });

    const submitOrganisationUpdateForm = (values: OrganisationDataPlusUrl) => {
        delete values.urlPrefix;
        updateOrganisationAction({
            variables: {
                input: {
                    // @ts-ignore
                    ...{ id: parseInt(id) },
                    ...values
                }
            }
        })
    }

    const submitUserCreateForm = (values: UserFormData) => {
        createUserAction({
            variables: {
                input: {
                    // @ts-ignore
                    ...{ organisationId: parseInt(id) },
                    ...values
                }
            }
        })
    }

    const submitAssessmentOptionsUpdateForm = (values: AssessmentOptions) => {
        updateAssessmentOptions({
            variables: {
                // @ts-ignore
                id: assessmentOptionsData?.id,
                input: {
                    ...values
                }
            }
        })
    }

    const userContext = useContext(UserContext)
    if(userContext?.organisation?.id !== 1) {
        return <Navigate to='/library/home' />
    }

    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Organisation Edit" subtitle={organisationFormData ? "Organisation: " + organisationFormData.venture : ''}/>
            <br/>
            <section className={styles.navigate}>
                { organisationFormData &&
                    <div className={styles.formBlock}>
                        <header className={styles.header}>Update Organisation</header>
                        <OrganisationForm formikRef={formikRefOrganisationForm} submitValues={(values: OrganisationDataPlusUrl) => {
                            submitOrganisationUpdateForm(values)
                        }} formData={organisationFormData} updating={true}/>
                        <button
                        className={styles.send}
                            type='button'
                            onClick={() => {
                                console.log('clicked')
                                formikRefOrganisationForm.current?.submitForm()
                            }}
                            disabled={updatingOrganisationError}
                        >{`Update Organisation`}</button>
                        {updatingOrganisationSuccessful && (
                        <span className={styles.sendSuccessful}>Organisation updated successful</span>
                        )}
                        {updatingOrganisationError && (
                        <span className={styles.sendFailed}>Oops, something went wrong with updating organisation: `{errorMessage}`</span>
                        )}
                    </div>
                }
                <hr/>
                <div className={styles.formBlock}>
                    <header className={styles.header}>Organisation Logo</header>
                    <FileUpload value={organisationFormData?.logoUrl} valueChanged={(value: string) => {
                        if(organisationFormData) {
                            organisationFormData.logoUrl = value;
                            setOrganisationFormData(organisationFormData)
                            submitOrganisationUpdateForm(organisationFormData)
                        }
                    }}></FileUpload>
                    {organisationFormData?.logoUrl &&
                        <div className={styles.logoBlock}>
                            <img src={organisationFormData?.logoUrl}></img>
                        </div>
                    }
                </div>
                <hr/>
                <div className={styles.formBlock}>
                    <header className={styles.header}>Users</header>
                    { id !== undefined &&
                        <UsersTable organisationId={parseInt(id)}></UsersTable>
                    }
                </div>
                <hr/>
                <div className={styles.formBlock}>
                    <header className={styles.header}>Add new user</header>
                    <AddUserForm formikRef={formikRefUserForm} formData={userFormData} submitValues={(values: UserFormData) => {
                        submitUserCreateForm(values)
                    }}></AddUserForm>
                    <button
                        className={styles.send}
                        type='button'
                        onClick={() => {
                            formikRefUserForm.current?.submitForm()
                        }}
                        disabled={updatingUserError}
                    >{`Create New User`}</button>
                    {updatingUserSuccessful && (
                        <span className={styles.sendSuccessful}>User created successful, password for user: {userPassword}</span>
                    )}
                    {updatingUserError && (
                        <span className={styles.sendFailed}>Oops, something went wrong with creating User: `{errorMessage}`</span>
                    )}
                </div>
                <div className={styles.formBlock}>
                    <header className={styles.header}>Assessment Options</header>
                    <AssessmentOptionsForm formikRef={formikRefAssOptionsForm} formData={assessmentOptionsData} submitValues={(values: AssessmentOptions) => {
                        submitAssessmentOptionsUpdateForm(values)
                    }}></AssessmentOptionsForm>
                    <button
                        className={styles.send}
                        type='button'
                        onClick={() => {
                            console.log('Clicked on button')
                            formikRefAssOptionsForm.current?.submitForm()
                        }}
                        // disabled={updatingAssessmentOptionsError}
                    >{`Update`}</button>
                    {updatingAssessmentOptionsSuccessful && (
                        <span className={styles.sendSuccessful}>Assessment options updated successful</span>
                    )}
                    {updatingAssessmentOptionsError && (
                        <span className={styles.sendFailed}>Oops, something went wrong with updating assessment options: `{errorMessage}`</span>
                    )}
                </div>
            </section>
        </div>
    )
};
